"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlTypes = void 0;
var ControlTypes;
(function (ControlTypes) {
    ControlTypes["TOGGLE"] = "Toggle";
    ControlTypes["RADIO"] = "Radio";
    ControlTypes["DROPDOWN"] = "Dropdown";
    ControlTypes["CHECKBOX"] = "Checkbox";
    ControlTypes["DISCRETE_SLIDER"] = "Discrete Slider";
    ControlTypes["SLIDER"] = "Slider";
    ControlTypes["BUTTON"] = "Push Button";
})(ControlTypes || (exports.ControlTypes = ControlTypes = {}));
//# sourceMappingURL=control.js.map